"use client";
import React, { ReactNode, memo } from "react";
import {
  Box,
  BoxProps,
  InputLabel,
  InputLabelProps,
  Tooltip,
} from "@mui/material";
import { InfoHexagonIcon, RequiredIcon } from "@/icons";
import { cn } from "@/utils/common.utils";
import AppTooltip from "../AppTooltip";

const AppFromLabelField = ({
  className,
  label,
  children,
  required = false,
  childrenWrapperProps,
  labelProps,
  helper,
  action,
}: AppFromLabelFieldProps) => {
  return (
    <Box className={className}>
      {label && (
        <InputLabel
          {...labelProps}
          required={false}
          className={cn(labelProps?.className)}
          sx={{
            marginBottom: "4px",
            fontWeight: "600",
            flex: "0 0 auto",
            ...labelProps?.sx,
          }}
        >
          <Box className="flex flex-row gap-1 items-center">
            {label}
            {required && (
              <Box className="text-error text-[8px]" component={"span"}>
                <RequiredIcon />
              </Box>
            )}
            {helper && (
              <AppTooltip title={helper} placement="bottom">
                <Box component={"span"} className="text-darkgreen text-qi-h5">
                  <InfoHexagonIcon />
                </Box>
              </AppTooltip>
            )}
          </Box>
          {action && action}
        </InputLabel>
      )}
      <Box {...childrenWrapperProps}>{children}</Box>
    </Box>
  );
};

export type AppFromLabelFieldProps = Pick<BoxProps, "children"> & {
  className?: string;
  label?: string | ReactNode;
  required?: boolean;
  labelProps?: Omit<InputLabelProps, "required">;
  childrenWrapperProps?: BoxProps;
  helper?: string | ReactNode;
  action?: ReactNode;
};

export default memo(AppFromLabelField);
